export default __webpack_public_path__ + "static/media/pwc.0f5a4f04.png";